import { forwardRef } from 'react'
import type { QueueItem as QueueItemType } from '../types'

interface DownloadBarProps {
  items: QueueItemType[]
  isConverting: boolean
  onConvert: () => void
  onDownloadAll: () => void
}

const DownloadBar = forwardRef<HTMLButtonElement, DownloadBarProps>(function DownloadBar(
  { items, isConverting, onConvert, onDownloadAll },
  ref,
) {
  const waiting = items.filter((it) => it.status === 'waiting').length
  const succeeded = items.filter((it) => it.status === 'succeeded').length
  const failed = items.filter((it) => it.status === 'failed').length
  const active = items.filter((it) => it.status === 'waiting' || it.status === 'converting').length
  const allDone = active === 0 && items.length > 0

  let label = 'Choose files to start'
  let action: (() => void) | undefined = undefined
  let disabled = true

  if (items.length > 0) {
    if (isConverting) {
      label = 'Converting...'
      disabled = true
    } else if (allDone) {
      if (succeeded > 0) {
        label = succeeded === 1 ? 'Download file' : 'Download all'
        action = onDownloadAll
        disabled = false
      } else if (failed > 0) {
        label = 'No files succeeded'
        disabled = true
      } else {
        label = 'All cancelled'
        disabled = true
      }
    } else if (waiting > 0) {
      label = `Convert ${waiting} file${waiting === 1 ? '' : 's'} →`
      action = onConvert
      disabled = false
    } else if (failed > 0) {
      label = `${failed} failed`
      disabled = true
    }
  }

  return (
    <button
      ref={ref}
      className="button convert"
      type="button"
      onClick={action}
      disabled={disabled}
      aria-busy={isConverting}
    >
      {label}
    </button>
  )
})

export default DownloadBar
